import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  EmailPlanPreviewPayload,
  Plan,
  PlanAdminPayload,
  PlanCapacityPayload,
  PlanResourcePayload,
  SoulPlanModel,
} from "../models/Plan/PlanModel";

export class PlanApi extends BaseApi {
  private static instance: PlanApi;

  public static get(): PlanApi {
    if (!this.instance) {
      this.instance = new PlanApi();
    }
    return this.instance;
  }

  public allPlans = BaseApi.createEndpoint<Plan[], null>(
    HttpMethodEnum.GET,
    "/plan/all",
  );

  public pushNewResource = BaseApi.createEndpoint<null, PlanResourcePayload>(
    HttpMethodEnum.POST,
    "/plan/resource",
  );

  public createPlan = BaseApi.createEndpoint<Plan, PlanAdminPayload>(
    HttpMethodEnum.POST,
    "/plan/admin",
  );

  public updatePlan = BaseApi.createEndpoint<Plan, PlanAdminPayload>(
    HttpMethodEnum.PUT,
    "/plan/admin",
  );

  public createCapacity = BaseApi.createEndpoint<null, PlanCapacityPayload>(
    HttpMethodEnum.POST,
    "/plan/admin/capacity",
  );

  public deleteResource = BaseApi.createEndpoint<null, PlanResourcePayload>(
    HttpMethodEnum.DELETE,
    "/plan/resource",
  );

  public postEmailPreview = BaseApi.createEndpoint<
    null,
    EmailPlanPreviewPayload
  >(HttpMethodEnum.POST, "/plan/emailPreview");

  public getPlan = BaseApi.createEndpoint<
    { soulPlan: SoulPlanModel; plans: Plan[] },
    null
  >(HttpMethodEnum.GET, "/plan/");
}

export const planApi = PlanApi.get();
